// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "马克思主义基本原理",
      "tec": "刘君",
      "week": "6-17周",
      "add": "教学楼A座326电力"
    },
    {
      "sub": "高等数学基础（一）",
      "tec": "陈钢",
      "week": "6-17周",
      "add": "教学楼C座309教务"
    },
    {
      "sub": "电路",
      "tec": "高志强",
      "week": "6-18周",
      "add": "教学楼A座219电力"
    },
    0,
    {
      "sub": "军事理论",
      "tec": "黄明",
      "week": "13,15,17周",
      "add": "教学楼A座222电力"
    }
  ],
  "2": [
    {
      "sub": "基础英语（一）",
      "tec": "宋大明",
      "week": "6-17周",
      "add": "教学楼A座217电力"
    },
    {
      "sub": "中国近现代史纲要",
      "tec": "张慧",
      "week": "6-17周",
      "add": "教学楼B座223自控"
    },
    {
      "sub": "电路",
      "tec": "高志强",
      "week": "15周",
      "add": "教学楼A座219电力"
    },
    [
      {
        "sub": "形势与政策",
        "tec": "单超",
        "week": "6-9周",
        "add": "教学楼C座213教务"
      },
      {
        "sub": "就业创业指导",
        "tec": "赵毅王刚王祎雪刘东岩",
        "week": "13-16周",
        "add": "大活礼堂"
      }
    ],
    0
  ],
  "3": [
    {
      "sub": "电路",
      "tec": "高志强",
      "week": "6-18周",
      "add": "教学楼A座217电力"
    },
    {
      "sub": "马克思主义基本原理",
      "tec": "刘君",
      "week": "6-17周",
      "add": "教学楼C座114教务"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "电路",
      "tec": "高志强",
      "week": "6-18周",
      "add": "教学楼C座210教务"
    },
    {
      "sub": "基础英语（一）",
      "tec": "宋大明",
      "week": "7,9,11,13,15,17周",
      "add": "教学楼A座217电力"
    },
    0,
    0,
    {
      "sub": "军事理论",
      "tec": "黄明",
      "week": "13-18周",
      "add": "教学楼A座222电力"
    }
  ],
  "5": [
    {
      "sub": "高等数学基础（一）",
      "tec": "陈钢",
      "week": "6-17单周",
      "add": "教学楼C座310教务"
    },
    {
      "sub": "中国近现代史纲要",
      "tec": "张慧",
      "week": "6-17周",
      "add": "教学楼B座223自控"
    },
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
